import React from 'react';
import Button from '../button/button';

const NoteButton = ({ 
  parameter, 
  loading, 
  onSave, 
  className = "custom-button" 
}) => {
  return (
    <div className="d-flex justify-content-end my-3">
      <Button
        variant="submit"
        size="sm"
        clickHandler={() => onSave(parameter)}
        disabled={loading}
        styles={{
            backgroundColor: 'var(--primary-blue-color)',
            color: 'var(--primary-white-color)',
            borderRadius:"16px",
            padding:"6px 10px"           
        }}
      >
        {loading ? 'Saving...' : 'Save Note'}
      </Button>
    </div>
  );
};

export default NoteButton;
